import classNames from "classnames";
import { BiLock } from "components/Icons/BiLock";
import { BiUnlock } from "components/Icons/BiUnlock";
import { getResource, isResourceKey, useTranslations } from "providers";
import React from "react";

interface DisplayLockedProps {
  name: string;
  value: boolean | undefined;
  entityName: string;
  showLabel?: boolean;
}

export const DisplayLocked: React.FC<DisplayLockedProps> = ({ name, value, entityName, showLabel = false }) => {
  if (!entityName) {
    throw new Error('Property "entityName" is mandatory!');
  }

  const i18n = useTranslations();

  const activeKey = `${entityName}_${name}_Active_Tooltip` as const;
  const inactiveKey = `${entityName}_${name}_Inactive_Tooltip` as const;
  const tooltip = value
    ? isResourceKey(activeKey)
      ? getResource(activeKey)
      : ""
    : isResourceKey(inactiveKey)
      ? getResource(inactiveKey)
      : "";

  const label = showLabel ? (value ? i18n.Yes : i18n.No) : "";

  const cellClass = classNames("global-tooltip-trigger", {
    "locked-active": value,
    "locked-inactive": !value,
  });

  return (
    <span sbb-tooltip={tooltip} className={cellClass}>
      {value ? <BiLock /> : <BiUnlock />}
      {label}
    </span>
  );
};
